(() => {
  // CONFIG — Adjust this to slow down or speed up animation
  const REVEAL_LINES = 4;
  const TRANSITION_MS = 2000; // Adjustable animation speed

  function prepareWrapper(wrapper) {
    if (!wrapper || wrapper.dataset.readmoreReady === "true") return;

    const desc = wrapper.querySelector(".description");
    const button = wrapper.querySelector(".toggle-readmore");
    const extra = wrapper.querySelector(".extra-content");

    if (!desc || !button) return;

    const computedStyle = getComputedStyle(desc);
    let lineHeight = parseFloat(computedStyle.lineHeight);

    if (!lineHeight || isNaN(lineHeight)) {
      const fontSize = parseFloat(computedStyle.fontSize) || 16;
      lineHeight = fontSize * 1.5;
    }

    const collapsedHeight = Math.round(REVEAL_LINES * lineHeight);

    wrapper.dataset.collapsedHeight = collapsedHeight;
    wrapper.dataset.readmoreReady = "true";

    desc.classList.add("collapsed");
    desc.classList.remove("expanded");
    desc.style.overflow = "hidden";
    desc.style.maxHeight = collapsedHeight + "px";
    desc.style.transition = `max-height ${TRANSITION_MS}ms ease`;

    if (extra) extra.classList.remove("show");

    button.hidden = false;
    button.textContent = "Read More";
    button.setAttribute("aria-expanded", "false");
  }

  function initAllWrappers() {
    document.querySelectorAll(".readmore-wrapper").forEach(prepareWrapper);
  }

  // CLICK HANDLER — Using Event Delegation
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".toggle-readmore");
    if (!btn) return;

    const wrapper = btn.closest(".readmore-wrapper");
    const desc = wrapper?.querySelector(".description");
    const extra = wrapper?.querySelector(".extra-content");
    if (!wrapper || !desc) return;

    const collapsedHeight = parseFloat(wrapper.dataset.collapsedHeight);

    const expanding = !desc.classList.contains("expanded");

    if (expanding) {
      desc.classList.add("expanded");
      desc.style.maxHeight = desc.scrollHeight + "px";
      if (extra) extra.classList.add("show");
      btn.textContent = "Read Less";
      btn.setAttribute("aria-expanded", "true");
    } else {
      desc.classList.remove("expanded");
      desc.style.maxHeight = collapsedHeight + "px";
      if (extra) extra.classList.remove("show");
      btn.textContent = "Read More";
      btn.setAttribute("aria-expanded", "false");
    }
  });

  // Auto-init newly added content
  const observer = new MutationObserver(() => initAllWrappers());
  observer.observe(document.body, { childList: true, subtree: true });

  // Init when full page is ready
  window.addEventListener("load", initAllWrappers);

  // Re-init when Shopify variants update product info
  document.addEventListener("variant:changed", initAllWrappers);
  document.addEventListener("product:variant:changed", initAllWrappers);
})();